export default __webpack_public_path__ + "static/media/background_aae_hud_factory_section_demo.0cad3075.jpg";